
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

const firebaseEnabled = Boolean(process.env.REACT_APP_API_KEY);

let fb = null;
let db = null;
let storage = null;
let auth = null;

if (firebaseEnabled) {
  fb = firebase.apps.length ? firebase.app() : firebase.initializeApp(firebaseConfig);
  db = firebase.firestore();
  storage = firebase.storage();
  auth = firebase.auth();
} else if (process.env.NODE_ENV === 'development') {
  console.warn(
    'Firebase is not configured. Add REACT_APP_API_KEY and related REACT_APP_* values to .env to enable login and data features.'
  );
}

export { fb, db, storage, auth };

export const static_img =
  'https://firebasestorage.googleapis.com/v0/b/bridgetech-advance-project.appspot.com/o/profile_images%2Fprofile.jpg?alt=media&token=b3c94ada-1b08-4834-bbd1-647882c7195a';
